import * as $ from "jquery";
import imkt from '../../imkt';

export default class CodeBlock {
  domRoot: JQuery<HTMLElement>;
  params: {};
  
  constructor(domRoot: HTMLElement, params: {}) {
  this.domRoot = $(domRoot);
  this.params = { ...params };

  import("../../common/code-blocks").then(({ default: initialize }) => initialize());
  }
}

imkt.components.CodeBlock = CodeBlock;
